import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    _createVNode("path", { d: "M5.927 13.177l4.896 4.896a.25.25 0 00.354 0l6.25-6.25a.25.25 0 00.073-.177V8.104c0-.01 0-.02-.002-.03L17.5 8a1.5 1.5 0 00-1.574-1.498.25.25 0 00-.03-.002h-3.543a.25.25 0 00-.176.073l-6.25 6.25a.25.25 0 000 .354z" }),
    _createVNode("path", {
      "stroke-linecap": "round",
      d: "M11.5 15v-4.5"
    }),
    _createVNode("path", { d: "M9.854 12.396a.5.5 0 11-.708.708.5.5 0 01.708-.708zM13.854 12.396a.5.5 0 11-.708.708.5.5 0 01.708-.708z" })
  ]))
}